var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServiceLogo = function SvgServiceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_229557)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_215_229557)",
    d: "M17.71 11.896a3.35 3.35 0 0 0-4.568-1.512l-6.29 3.282a3.32 3.32 0 0 0-1.785 2.944v4.532c0 .393.415.648.765.47l10.378-5.266a3.353 3.353 0 0 0 1.5-4.45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F90667",
    d: "M4.74 9.748a3.33 3.33 0 0 0 4.463 1.527l6.072-2.988a3.32 3.32 0 0 0 1.854-2.98V.843a.527.527 0 0 0-.757-.473L6.273 5.295A3.33 3.33 0 0 0 4.74 9.748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_215_229557",
    x1: 13.139,
    x2: 12.973,
    y1: 9.34,
    y2: 16.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB024C",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB024C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_229557"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgServiceLogo;